/**
 * Gender normalization utilities
 * Handles conversion between numeric gender values (1=male, 0=female) and string values
 */

/**
 * Normalize gender to string 'male' or 'female'.
 * Accepts either a character-like object ({ gender }) or a raw value (number | string).
 * @param {Object|string|number|null|undefined} characterOrRaw
 * @returns {'male'|'female'}
 */
export function normalizeGender(characterOrRaw) {
    const raw = characterOrRaw && typeof characterOrRaw === 'object' && 'gender' in characterOrRaw
        ? characterOrRaw.gender
        : characterOrRaw;
    if (raw === undefined || raw === null) return 'female';
    if (typeof raw === 'number') return raw === 1 ? 'male' : 'female';
    if (typeof raw === 'string') return raw.toLowerCase().trim() === 'male' ? 'male' : 'female';
    return 'female';
}

/**
 * Normalize gender for filter/outfit contexts.
 * Maps 'm'/'1' → 'male', 'f'/'0' → 'female', 'all'/'any' → 'all', unknown/empty → ''.
 * @param {string|number|null|undefined} value
 * @returns {'male'|'female'|'all'|''}
 */
export function normalizeGenderForFilter(value) {
    if (value === undefined || value === null) return '';
    const normalized = String(value).toLowerCase().trim();
    if (normalized === '1' || normalized === 'male' || normalized === 'm') return 'male';
    if (normalized === '0' || normalized === 'female' || normalized === 'f') return 'female';
    if (normalized === 'all' || normalized === 'any') return 'all';
    return '';
}
